import React from "react";
import PropTypes from "prop-types";
import models from "../../../../types/models";
import is from "is_js";
import { observer } from "mobx-react-lite";
import config from "../../../../config";

export default observer(function SwiperImage({
  opacityCard,
  isPositive,
  isNegative,
  isNeutral,
  card,
}) {
  SwiperImage.propTypes = {
    opacityCard: PropTypes.number,
    isPositive: PropTypes.bool,
    isNegative: PropTypes.bool,
    isNeutral: PropTypes.bool,
    card: PropTypes.oneOfType([models.gameCard, models.compromiseGameCard]),
  };
  const imageSrc =
    window?.isRNWebView && window?.RNPlatform === "android"
      ? `${config.staticApiUrl}mobile/${card.cardUrl}`
      : `${config.staticApiUrl}${card.cardUrl}`;
  return (
    <img
      style={{ opacity: opacityCard }}
      draggable={false}
      className={`in-game-page__main__swipe-card__wrapper__image ${
        isPositive && "positive-swipe-opacity"
      } 
      ${isNegative && "negative-swipe-opacity"} 
      ${isNeutral && "neutral-swipe-opacity"}
      ${
        is.mobile() &&
        "in-game-page__main__swipe-card__wrapper__image__mobile-safari"
      }
      ${
        is.mobile() &&
        "is in-game-page__main__swipe-card__wrapper__image_low-mobile"
      }
      `}
      src={imageSrc}
      alt=""
    />
  );
});
